(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class StickyBuyButtons {
    constructor(element) {
      this.originalElement = element;
      this.isSticky = element.dataset.sticky === 'true';
      this.offset = parseInt(element.dataset.stickyOffset) || 20;
      this.lastScrollTop = 0;
      this.scrollThreshold = 100;
      this.isVisible = false;
      this.originalPosition = null;
      this.stickyClone = null;

      if (this.isSticky) {
        this.init();
      }
    }

    init() {
      // Wait for next frame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        this.findStickyClone();
        this.moveToBody();
        this.calculateOriginalPosition();
        this.addBodyClass();
        this.bindEvents();
        this.checkScrollPosition();
        // Ensure sticky clone starts in hidden state
        this.initializeStickyState();
      });
    }

    initializeStickyState() {
      if (!this.stickyClone) return;

      // Ensure sticky clone starts hidden with proper CSS classes
      this.stickyClone.style.display = 'block';
      this.stickyClone.classList.add('buy-buttons-block--hidden');
      this.stickyClone.style.zIndex = 'var(--layer-temporary)';
    }

    findStickyClone() {
      // Find the sticky clone that corresponds to this original element
      const blockId =
        this.originalElement.dataset.blockId || this.originalElement.classList[1]?.replace('buy-buttons-block--', '');

      this.stickyClone = document.querySelector(`[data-sticky-clone="true"][data-original-block-id="${blockId}"]`);

      if (!this.stickyClone) {
        console.warn('Sticky clone not found for:', this.originalElement);
        return;
      }

      // Ensure sticky clone starts hidden
      this.stickyClone.style.display = 'none';
    }

    moveToBody() {
      if (!this.stickyClone) return;

      // Move the sticky clone to the document body to avoid stacking context issues
      if (this.stickyClone.parentNode !== document.body) {
        document.body.appendChild(this.stickyClone);
        console.log('Moved sticky clone to body');
      }
    }

    calculateOriginalPosition() {
      // Get the original position of the buy buttons block
      const rect = this.originalElement.getBoundingClientRect();
      this.originalPosition = {
        top: rect.top + window.pageYOffset,
        bottom: rect.bottom + window.pageYOffset,
        height: rect.height,
      };
    }

    addBodyClass() {
      document.body.classList.add('has-sticky-buttons');
    }

    bindEvents() {
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.checkScrollPosition();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener(
        'resize',
        () => {
          this.calculateOriginalPosition();
          this.checkScrollPosition();
        },
        { passive: true }
      );

      // Periodically ensure sticky buttons stay on top
      if (this.isSticky) {
        setInterval(() => {
          if (this.isVisible) {
            this.ensureOnTop();
          }
        }, 1000); // Check every second
      }
    }

    checkScrollPosition() {
      if (!this.originalPosition || !this.stickyClone) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;

      // Check if the original buttons are still visible in the viewport
      // Original buttons are visible if their bottom edge is above the top of the viewport
      const originalButtonsVisible = this.originalPosition.bottom > scrollTop;

      // Debug logging
      console.log('Sticky Debug:', {
        scrollTop,
        originalBottom: this.originalPosition.bottom,
        originalButtonsVisible,
        shouldShow: !originalButtonsVisible,
        isVisible: this.isVisible,
      });

      // Only show sticky buttons when original buttons are not visible
      const shouldShow = !originalButtonsVisible;

      if (shouldShow !== this.isVisible) {
        this.toggleVisibility(shouldShow);
      }

      this.lastScrollTop = scrollTop;
    }

    toggleVisibility(show) {
      this.isVisible = show;

      if (show) {
        // Ensure element is visible but hidden with CSS for smooth transition
        this.stickyClone.style.display = 'block';
        // Force reflow to ensure transition works
        this.stickyClone.offsetHeight;
        // Remove hidden class to trigger transition
        this.stickyClone.classList.remove('buy-buttons-block--hidden');
        // Ensure proper z-index when visible
        this.stickyClone.style.zIndex = 'var(--layer-temporary)';
      } else {
        // Add hidden class to trigger transition
        this.stickyClone.classList.add('buy-buttons-block--hidden');
        // Hide display after transition completes
        setTimeout(() => {
          if (!this.isVisible) {
            this.stickyClone.style.display = 'none';
          }
        }, 400); // Match CSS transition duration
      }
    }

    // Method to ensure sticky buttons stay on top
    ensureOnTop() {
      if (this.stickyClone && this.isVisible) {
        // Ensure proper z-index
        this.stickyClone.style.zIndex = 'var(--layer-temporary)';
        // Check if any other elements are overlapping
        const rect = this.stickyClone.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
          // If position is wrong, force correct positioning
          this.stickyClone.style.bottom = '0';
          this.stickyClone.style.left = '0';
          this.stickyClone.style.right = '0';
        }
      }
    }
  }

  // Initialize sticky behavior for all sticky buy button blocks
  document.addEventListener('DOMContentLoaded', () => {
    const stickyBlocks = document.querySelectorAll('[data-sticky="true"]');
    stickyBlocks.forEach((block) => new StickyBuyButtons(block));
  });

  // Handle dynamic content loading (for sections that load after page load)
  document.addEventListener('shopify:section:load', (event) => {
    const stickyBlock = event.target.querySelector('[data-sticky="true"]');
    if (stickyBlock) {
      new StickyBuyButtons(stickyBlock);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
